export const MFA_REQUIRED_MESSAGE = "Two-factor authentication required";

/** The `code` our API routes send with a 401 for a session that owes 2FA. */
export const MFA_REQUIRED_CODE = "mfa_required";

/** PostgREST's answer to the same session, raised by `pgrst_pre_request`. */
export const POSTGREST_MFA_REQUIRED_CODE = "PT401";

export function isMfaRequiredError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const { code, message } = error as { code?: unknown; message?: unknown };
  return (
    code === POSTGREST_MFA_REQUIRED_CODE ||
    code === MFA_REQUIRED_CODE ||
    // API query hooks rethrow the response's `error` text without its code.
    message === MFA_REQUIRED_MESSAGE
  );
}
